<template>
    <v-dialog v-model="modal" width="800px" max-width="100%">
        <v-card v-if="offer" width="800px" max-width="100%" class="pa-md-3">
            <v-card-text class="text-black">
                <h2 class="pt-5 pt-md-2">
                    {{ offer.planName }}
                </h2>
                <div
                    v-if="offer.planDescription"
                    class="modal-window__description text-subtitle-2"
                    v-html="offer.planDescription"
                />
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_INSURANCE_INFO_MODAL} from '@/utils/event-bus'

    @Component
    export class InsuranceInfoModal extends Vue {
        offer = null
        modal = false

        mounted() {
            EventBus.$on(SHOW_INSURANCE_INFO_MODAL, this.showModal)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_INSURANCE_INFO_MODAL, this.showModal)
        }

        showModal({offer}) {
            this.offer = offer
            this.modal = true
        }
    }

    export default InsuranceInfoModal
</script>

<style lang="scss" scoped>
    .modal-window__description {
        padding: 0;

        :deep(p) {
            margin: 0;
        }
    }
</style>
